import React from "react";
import Header from "../../Components/Header/index"
import Footer from "../../Components/Footer/index"
import SearchPage from "./Page"

export default class extends React.Component {
    componentDidMount() {
    }

    render() {
        return (
            <div>
                <Header {...this.props}/>
                <SearchPage searchKeyParam={this.props.params.splat}/>
                <Footer/>
            </div>
        )
    }
}


